<div ng-controller="manageTasksController as ctrl" class="modal-view manage-tasks-view">
    <c-auto-form config="ctrl.autoFormConfig"></c-auto-form>
    <div id="managed-tasks-component"></div>
</div>
